import { render } from "./FreshbooksClientInvoicesModal.vue?vue&type=template&id=3b5cb2cc"
import script from "./FreshbooksClientInvoicesModal.vue?vue&type=script&lang=js"
export * from "./FreshbooksClientInvoicesModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__